(function($) {
	'use strict';

	var $deliveryInputs = $('[data-address-type="delivery"]');
	var $billingInputs = $('[data-address-type="billing"]');
	var inputName, key;

	function clearValidation($input) {
		$input.parent()
			.removeClass('has-success')
			.removeClass('has-error')
			.removeClass('has-danger')
			.find('.with-errors')
				.removeClass('.with-errors')
				.html('');
	}

	$('[data-checkout-address-copy]').click(function () {
	    if ($(this).prop('checked')) {
			if ($('[name="optUseAddress"]:checked').length > 0) {
				var $selectedAddress = $('[name="optUseAddress"]:checked');
				$billingInputs.each(function() {
					$(this).val($selectedAddress.attr('data-' + $(this).attr('data-address-key')));
				});
			} else {
				$billingInputs.each(function() {
					$(this).val($deliveryInputs.filter('[data-address-key="' + $(this).attr('data-address-key') + '"]').val());
				});
			}
		} else {
			$billingInputs.each(function() {
				$(this).val('');
				clearValidation($(this));
			});
		}
	});

})($jq);
